import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=0eb52330&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb52330')) {
      api.createRecord('0eb52330', component.options)
    } else {
      api.reload('0eb52330', component.options)
    }
    module.hot.accept("./blank.vue?vue&type=template&id=0eb52330&", function () {
      api.rerender('0eb52330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/waiting/blank.vue"
export default component.exports